<div class="wrapper">
  <div class="back-button">
    <button mat-mini-fab [matTooltip]="'Back' | translate" (click)="onClickBackButton()">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
  <div class="session-share">
    <app-chat-share [organization]="organization" [sharable]="session">
      <button mat-mini-fab [matTooltip]="'Share' | translate">
        <mat-icon>share</mat-icon>
      </button>
    </app-chat-share>
  </div>

  <div class="info-box" *ngIf="sessionRow">
    <h1>{{ session.name }}</h1>

<!-- display edit form if exists-->
    <ng-content></ng-content>

    <div fxLayout="row">
      <div fxFlex="100">
        <sessions-session-general-panel
          [organization]="organization"
          [isEditable]="false"
          [(session)]="sessionRow"
          [(sessionItems)]="sessionItems"
          [isMobileDisplay]="true"
        >
        </sessions-session-general-panel>
      </div>
    </div>

    <div class="general-comment" *ngIf="session.comment">
      <div class="label">{{ 'generalComment' | translate }}</div>
      <div class="value">{{ session.comment }}</div>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="20px">
    <div fxFlex="100">
      <div class="session-items-container">
        <div *ngFor="let item of sessionItems; index as i">
          <session-bloc *ngIf="item.type === 'BLOC'"
                        [blocNumber]="getBlocNumber(item)"
                        [data]="item"
                        [organization]="organization"
                        [isEditable]="false"
                        [isMobileDisplay]="true"
                        [stopwatchSelected]="selectedStopwatchSessionIndex === i"
                        [selectedStopwatchExerciseIndex]="selectedStopwatchExerciseIndex"
                        (openStopwatch)="onOpenStopwatch(i, $event)"
          >
          </session-bloc>
          <session-comment *ngIf="item.type === 'COMMENT'"
                           [data]="item"
                           [isEditable]="false"
          >
          </session-comment>
          <session-rest *ngIf="item.type === 'REST'"
                        [data]="item"
                        [isEditable]="false"
          >
          </session-rest>
        </div>
      </div>
    </div>
  </div>

  <session-stopwatch *ngIf="stopwatchData"
                     [title]="stopwatchData.exercice.exercice.name"
                     [duration]="stopwatchData.sessionItemExercice.duration * 1000"
                     [style.display]="stopwatchDisplay ? 'block' : 'none'"
                     (close)="onCloseStopwatch()">
  </session-stopwatch>
</div>
